<!-- 采集数据 win窗体 -->
<template>
    <div class="height-percent-100 recordPoint">
        <h1>{{$t('integration.record_point_data')}}</h1>
        <carrierLogpoint :detailObj="detailObj" :getCarrierType="getCarrierType" v-if="detailObj" :isShowEdit2="true"></carrierLogpoint>
    </div>
</template>

<script>
import carrierLogpoint from '@/pages/business/components/detail/carrierLogpoint.vue'
import detailObj from './mixin/detailObj';
export default {
    mixins:[detailObj],
    components:{
        carrierLogpoint
    },
    data(){
        return {
            getCarrierType:null,
        }
    },
    async mounted(){
        if(!sessionStorage.getItem('getCarrierStatus') && !sessionStorage.getItem('getCarrierType')){
            const { result } = await carrierShareCarrierType({ typeCode, })
            const { result: results } = await carrierShareParam({ code: 'carrier_status_item', type: 0 });
            sessionStorage.setItem(
                'getCarrierStatus',
                JSON.stringify(results)
            )
            sessionStorage.setItem(
                'getCarrierType',
                JSON.stringify(result)
            )
        }
        this.getCarrierType = JSON.parse(sessionStorage.getItem('getCarrierType') || '{}');

    }
}
</script>

<style scoped lang="scss">
.recordPoint{
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    padding: 15px;
    h1 {
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        border-bottom: 1px solid #ccc;
        padding-bottom: 15px;
        margin-bottom: 15px;
        .icon {
          position: absolute;
          top: 15px;
          right: 10px;
          font-size: 22px;
          font-weight: bold;
          cursor: pointer;

          &:hover {
              color: red;
          }
      }
    }

}
</style>